import React from 'react';
import { connect } from 'react-redux';

import TravellerButton from '../TravellerButton/TravellerButton';
import TravellerOuter from '../TravellerOuter/TravellerOuter';
import TravellerInner from '../TravellerInner/TravellerInner';
import TravellerCount from '../TravellerCount/TravellerCount';

import HotelRoom from '../HotelRoom/HotelRoom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import * as travellersActions from '../../../store/actions/index';

const travellers = (props) => {

    return (
        <TravellerOuter>
            <p className={`u-textColorLight mb-2`}>Rooms &amp; Guests</p>
            {
                props.rooms.map((room, i) => {
                    if (props.activeRoom === room.id) {
                        return <React.Fragment key={i}>
                            <div className={`mb-2 u-flex justify-content-between`}>
                                <p className={`u-fontSize13 u-textColorDark u-fontWeightRegular`}>Room {room.id}:</p>
                                {
                                    room.id !== 1 ? <div className={`ml-2 u-cursorPointer`} onClick={() => props.onRemoveHotelRoom(room.id)}>
                                        <FontAwesomeIcon icon="times" color="#666" size="sm" />
                                    </div> : null
                                }
                            </div>
                            <div className={`u-borderRadius4 u-borderTraveller mb-2`}>
                                <TravellerInner>
                                    <TravellerButton 
                                        onClick={() => {
                                            props.onResetSlideCounter();
                                            props.onClickAdult();
                                        }}
                                        isactive={props.adultActive.toString()}
                                        >Adult { room.noOfAdults > 0 ? <TravellerCount>{room.noOfAdults}</TravellerCount> : null }</TravellerButton>
                                    <TravellerButton 
                                        onClick={() => {
                                            props.onResetSlideCounter();
                                            props.onClickChild();
                                        }} 
                                        isactive={props.childActive.toString()}
                                        >Children { room.noOfChildren > 0 ? <TravellerCount>{room.noOfChildren}</TravellerCount> : null }</TravellerButton>
                                </TravellerInner>
                                <div className={`pl-3 pr-4 pt-3 pb-2`}>
                                    <HotelRoom key={i} room={room} />
                                </div>
                            </div>
                        </React.Fragment>;
                    } else {
                        return <div className={`u-flex justify-content-between align-items-center pb-2 u-borderBottomNormal mb-3`} key={i}>
                            <div className={`u-flex`}>
                                <span className={`mr-2 u-textColorDark u-fontSize13 u-fontWeightRegular`}>Room&nbsp;{room.id}:</span>
                                <div className={`u-textColorDark u-fontSize13 u-fontWeightMedium`}>
                                    <span>{room.noOfAdults}&nbsp;Adults</span>,&nbsp;
                                    <span>{room.noOfChildren}&nbsp;Children</span>&nbsp;
                                </div>
                            </div>
                            <div className={`u-flex`}>
                                <div>
                                    <span className={`u-textTransformUppercase u-textColorPrimary u-fontSize11 u-fontWeightMedium u-cursorPointer`} onClick={() => props.onSetActiveRoom(room.id)}>EDIT</span>
                                </div>
                                <div className={`ml-2 u-cursorPointer`} onClick={() => props.onRemoveHotelRoom(room.id)}>
                                    <FontAwesomeIcon icon="times" color="#666" size="sm" />
                                </div>
                            </div>
                        </div>
                    }
                })
            }
            {
                props.roomCount < 4 ? <div className={`u-flex justify-content-between align-items-center`}>
                    <span className={`u-fontSize13 u-textColorLight u-fontWeightRegular`}>
                        { props.adultActive ? 'Above 12 Years' : props.childActive ? 'Below 12 Years' : null }
                    </span>
                    <p className={`u-textAlignRight u-fontSize11 u-textColorPrimary u-fontWeightMedium pl-1 u-cursorPointer u-textUppercase`} onClick={() => props.onAddHotelRoom(props.rooms.length)}>&#x0002B;Add Room</p>
                </div> : null
            }
        </TravellerOuter> 
    );
} 

const mapStateToProps = state => {
    return {
        adultActive: state.hotelTravellers.adultActive,
        childActive: state.hotelTravellers.childActive,
        roomCount: state.hotelTravellers.roomCount,
        rooms: state.hotelTravellers.rooms,
        activeRoom: state.hotelTravellers.activeRoom
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onClickAdult: () => dispatch(travellersActions.clickHotelAdult()),
        onClickChild: () => dispatch(travellersActions.clickHotelChild()),
        onAddHotelRoom: (value) => dispatch(travellersActions.addHotelRoom(value)),
        onRemoveHotelRoom: (value) => dispatch(travellersActions.removeHotelRoom(value)),
        onResetSlideCounter: () => dispatch(travellersActions.resetSlideCounter()),
        onSetActiveRoom: (id) => dispatch(travellersActions.setActiveRoom(id))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(travellers);


// WEBPACK FOOTER //
// ./src/components/Travellers/HotelTravellers/HotelTravellers.js